"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDispatcher = exports.AppEvent = void 0;
var AppEvent = /** @class */ (function () {
    function AppEvent(_type) {
        this._type = _type;
        this.defaultPrevented = false;
    }
    AppEvent.prototype.preventDefault = function () {
        this.defaultPrevented = true;
    };
    AppEvent.prototype.isDefaultPrevented = function () { return this.defaultPrevented; };
    Object.defineProperty(AppEvent.prototype, "type", {
        get: function () { return this._type; },
        enumerable: false,
        configurable: true
    });
    return AppEvent;
}());
exports.AppEvent = AppEvent;
var EventListener = /** @class */ (function () {
    function EventListener(type, listener, thisArg) {
        this.type = type;
        this.listener = listener;
        this.thisArg = thisArg;
    }
    return EventListener;
}());
var EventDispatcher = /** @class */ (function () {
    function EventDispatcher() {
        this.listeners = Array();
        this.on = this.addEventListener;
    }
    EventDispatcher.prototype.hasEventListener = function (type, listener) {
        for (var i = 0, l = this.listeners.length; i < l; i++) {
            if (this.listeners[i].type === type && this.listeners[i].listener === listener) {
                return true;
            }
        }
        return false;
    };
    EventDispatcher.prototype.addEventListener = function (type, listener, thisArg) {
        if (thisArg === void 0) { thisArg = null; }
        if (this.hasEventListener(type, listener)) {
            console.log("Event ** listener exists, " + type);
            return;
        }
        this.listeners.push(new EventListener(type, listener, thisArg));
    };
    EventDispatcher.prototype.removeEventListener = function (type, listener) {
        for (var i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i].listener === listener && this.listeners[i].type === type) {
                this.listeners.splice(i, 1);
                return;
            }
        }
    };
    EventDispatcher.prototype.dispatchEvent = function (event) {
        event.target = this;
        var listeners = this.listeners.slice(0);
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].type === event.type) {
                listeners[i].listener.call(listeners[i].thisArg, event);
            }
        }
    };
    return EventDispatcher;
}());
exports.EventDispatcher = EventDispatcher;
